export default {
  apiKey: "AIzaSyDOHqIdFfbVME2I4iba3tOMAYERI7Hnm6E",
  authDomain: "sv-behr.firebaseapp.com",
  databaseURL: "https://sv-behr.firebaseio.com",
  projectId: "sv-behr",
  storageBucket: "sv-behr.appspot.com",
  messagingSenderId: "291500098469",
  appId: "1:291500098469:web:ca4fb1f925a67a54d3de4c",
};
